<body [class.darkMode]="darkModeService.darkMode">
  <mat-toolbar color="primary">
    <div class="footer-box">
      UI: {{ uiVersion }} | API: {{ apiVersion}}
    </div>
  </mat-toolbar>
</body>